<template>
  <header class="navbar-wrapper">
    <nav class="navbar navbar-expand-lg navbar-light">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-content" aria-controls="navbar-content" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link :to="'/'" class="navbar-brand text-hide" exact>Vendoscope</router-link>

      <div class="collapse navbar-collapse" id="navbar-content">
        <ul class="navbar-nav mr-auto">
          <template v-for="section in navElements">
            <router-link
              class="nav-item"
              tag="li"
              :to="section.route"
              v-if="!section.dropdown && canSeeNavItem(section)"
            >
              <a class="nav-link">{{section.label}}</a>
            </router-link>
            <li
              class="nav-item dropdown"
              v-else-if="section.dropdown && section.dropdown.some((item) => canSeeNavItem(item))"
            >
              <router-link class="nav-link dropdown-toggle" :to="section.route" event="" data-toggle="dropdown">
                {{section.label}}
              </router-link>
              <div class="dropdown-menu">
                <router-link
                  v-for="subsection in section.dropdown"
                  v-if="canSeeNavItem(subsection)"
                  :key="subsection.route"
                  class="dropdown-item"
                  :to="`${section.route}${subsection.route}`"
                  v-text="subsection.label"
                />
              </div>
            </li>
          </template>
        </ul>

        <template v-if="$root.user">
          <ul class="navbar-nav navbar-user">
            <router-link v-if="$root.isDev" class="nav-item" tag="li" to="/dev"><a class="nav-link">Dev</a></router-link>
            <li class="nav-item nav-support">
              <a class="nav-link" href="https://gkv24.ru/online/vendoscope" target="_blank" title="Техническая поддержка">
                <font-awesome-icon icon="question-circle" />
                <span class="navbar-icons-title">Поддержка</span>
              </a>
            </li>
            <!-- notify-primary-link -->
            <li class="nav-item dropdown nav-notify notifications-viewed" v-if="notificationsList.length > 0">
              <!-- 🕭 -->
              <a href="/notifications" class="nav-link notify-primary-link" title="Уведомления">
                <svg class="notify-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z" fill="#527f97"></path></svg>
                <span class="navbar-icons-title">Уведомления</span>
                <span class="navbar-icons-count-mini" v-if="notificationsUnread > 0"></span>
              </a>
              <a href="#" class="nav-link dropdown-toggle notifications-viewed-button" data-toggle="dropdown" title="Уведомления"  @click="checkShowClass">
                <svg class="notify-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z" fill="#527f97"></path></svg>
                <span class="navbar-icons-title">Уведомления</span>
                <span class="navbar-icons-count" v-if="notificationsUnread > 0">{{notificationsUnread}}</span>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <div class="dropdown-notices">
                  <template v-for="notification in notificationsList">
                    <div class="dropdown-row">
                      <div class="dropdown-row-innner">
                        <strong class="notify-title">{{notification.title}}</strong>
                        <div class="notify-body" v-html="notification.content"></div>
                        <a :href="'/notifications#'+notification.id" class="notify-underbody">Подробнее</a>
                      </div>
                    </div>
                  </template>
                </div>
                <hr>
                <div class="dropdown-notices-link-block">
                  <a href="/notifications" class="dropdown-notices-link">Все уведомления</a>
                </div>
              </div>
            </li>
            <li class="nav-item nav-news">
              <a class="nav-link" href="/news" title="Новости">ⓘ</a>
            </li>
            <li class="nav-item dropdown">
              <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
                <avatar
                  class="navbar-avatar-wrapper"
                  :username="`${$root.user.second_name} ${$root.user.first_name}`"
                  :size="30"
                ></avatar>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <div class="dropdown-header">
                  <h6 class="mb-1">{{ `${$root.user.second_name} ${$root.user.first_name}` }}</h6>
                </div>
                <template v-if="$root.checkPermission('web_personal_main')">
                <div v-if="$root.user.region" class="dropdown-header bg-light mb-2">
                  <div>Текущий баланс</div>
                  <div><strong>{{$root.user.region.money}} руб.</strong></div>
                  <button class="btn btn-sm btn-outline-primary my-1" @click="refill">Пополнить счет</button>
                </div>
                <router-link to="/personal" class="dropdown-item">Личный кабинет</router-link>
                <router-link v-if="$root.user.region" to="/payments/history" class="dropdown-item">История платежей</router-link>
                <router-link v-if="$root.user.region" to="/tariffs" class="dropdown-item">Тарифы</router-link>
                </template>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item" @click.prevent="logout">Выйти</a>
                <div v-if="$root.release" class="small text-muted mt-2" style="padding-left: 1.3rem;">
                  Версия {{ $root.release }}
                </div>
              </div>
            </li>
          </ul>
        </template>
      </div>
    </nav>
  </header>
</template>

<script>
  import RefillModal from '../components/payments/refill-modal'
  import Avatar from 'vue-avatar'
  import auth from '../auth'
  import api from '@/api'

  export default {
    name: 'Navbar',
    components: {Avatar},
    mounted() {
      this.getNotificationsShortList();

      this.markedAsRead = false;

      let pushmoose = document.createElement('script')
      pushmoose.setAttribute('src', 'https://pushmoose.com/static/script/vendoscope.js')
      pushmoose.setAttribute('async', '')
      pushmoose.setAttribute('defer', '')
      pushmoose.onload=callback
      document.head.appendChild(pushmoose)
    },
    asyncComputed: {
    },
    methods: {
      canSeeNavItem (item) {
        if (item.technicalOnly && !this.$root.isTechnicalAdmin()) return false
        return !item.hasOwnProperty('permission') || this.$root.checkPermission(item.permission)
      },
      getNotificationsShortList() {
            api.get('notifications/list/short')
                .then(({data}) => {
                  this.notificationsList = data.notifications;
                  this.notificationsUnread = data.unreadCount;
                    });
      },
      checkShowClass() {
        // Если метод уже был вызван, прерываем дальнейшие проверки
        if (this.markedAsRead) return;

        // Запускаем интервал проверки каждые 100мс
        let elapsed = 0;
        const interval = setInterval(() => {
          const targetElement = document.querySelector('.notifications-viewed');

          // Если элемент существует и имеет класс "show"
          if (targetElement && targetElement.classList.contains('show')) {
            if (!this.markedAsRead) {
              this.markNotificationsAsReadUntil();
              this.markedAsRead = true;
            }
            clearInterval(interval); // Отключаем интервал после выполнения метода
          }

          elapsed += 100;
          // Прерываем ожидание, если прошло более 2 секунд
          if (elapsed >= 2000) {
            clearInterval(interval);
          }
        }, 100);
      },
      markNotificationsAsReadUntil() {
        if (this.notificationsList && this.notificationsList.length > 0)
        {
          const notification_id = this.notificationsList[0].id;
          api.post('notifications/markNotificationsAsReadUntil', {
            notification_id: notification_id,
                })
                .then(({data}) => {
                    // console.log(data)
                    })
        } else {
          this.markedAsRead = false;
        }
      },
      logout () {
        auth.logout()
      },
      refill () {
        this.$root.showModal(RefillModal)
      },
    },
    data () {
      return {
        markedAsRead: false,
        notificationsList: [],
        notificationsUnread: 0,
        navElements: [
          { route: '/machines', label: 'Автоматы', permission: 'web_ta' },
          { route: '/billing',
            label: 'Админка',
            permission: 'web_billing_main',
            dropdown: [
              { route: '/cash-flow',
                label: 'Денежный поток',
                permission: 'web_billing_cash_flow'},
              { route: '/organizations',
                label: 'Организации',
                permission: 'web_billing_organizations'},
              // { route: '/unloading',
              //   label: 'Выгрузки',
              //   permission: 'web_billing_unloading'},
              // { route: '/panel',
              //   label: 'Панель',
              //   permission: 'web_billing_panel'},
              // { route: '/rights',
              //   label: 'Права',
              //   permission: 'web_billing_rights'},
              { route: '/notifications',
                label: 'Уведомления',
                permission: 'web_billing_notifications'},
              { route: '/settings/external-api',
                label: 'Настройки API',
                permission: 'web_billing_settings',
                technicalOnly: true},
              // { route: '/logs',
              //   label: 'Логи',
              //   permission: 'web_billing_logs'},
              // { route: '/settings',
              //   label: 'Настройки',
              //   permission: 'web_billing_settings'}
            ]},
          { route: '/reports',
            label: 'Отчеты',
            dropdown: [
              {route: '/sales', label: 'Продажи', permission: 'web_sales'},
              {route: '/expenditure', label: 'Расход продуктов', permission: 'web_rate'},
              {route: '/encashment', label: 'Инкассации', permission: 'web_collect'},
              {route: '/events', label: 'События', permission: 'web_events'},
              {route: '/downtime', label: 'Простои', permission: 'web_downtime'},
              {route: '/notifications', label: 'Уведомления', permission: 'web_alerts'},
              {route: '/receipts', label: 'Чеки', permission: 'web_bills'},
            ]},
          {route: '/service', label: 'Обслуживание', permission: 'web_service'},
          { route: '/settings',
            label: 'Настройки',
            dropdown: [
              {route: '/recipes', label: 'Рецептуры и продукты', permission: 'web_recipes'},
              {route: '/schedule', label: 'Расписание отчетов', permission: 'web_schedule'},
              {route: '/notifications', label: 'Уведомления', permission: 'web_alert_settings'},
              {route: '/users', label: 'Пользователи', permission: 'web_users'},
              {route: '/matrices', label: 'Матрицы', permission: 'web_matrix'},
              {route: '/catalogs', label: 'Управление справочниками', permission: 'admin_access'},
            ]},
          {route: '/orders', label: 'Заявки', permission: 'web_requests'},
          {route: '/modems', label: 'Модемы', permission: 'web_modems'},
          {route: '/receipts', label: 'Чеки', permission: 'web_bill_total'},
          { route: '/admin',
            label: 'Еще',
            dropdown: [
              {route: '/limits', label: 'Пороговые значения', permission: 'web_thresholds'},
              {route: '/documents', label: 'Документы и чек-листы', permission: 'web_checklist'},
              {route: '/models', label: 'Модели автоматов', permission: 'web_models'},
              {route: '/info', label: 'Информация', permission: 'web_personal_main'},
            ]},
        ],
      }
    },
  }
</script>

<style>
.navbar-nav .nav-notify .notify-body{
        -webkit-box-orient: vertical;
}
</style>

<style lang="scss">
  @import "boot";
  .page-index .navbar-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
  }
  .navbar {
    font-size: 1.1em;
    a {
      cursor: pointer;
    }
  }
  .navbar-avatar-wrapper {
    display: inline-flex !important;
    margin-top: -50px;
    margin-bottom: -50px;
    line-height: inherit !important;
    vertical-align: middle;
    font-family: inherit !important;
  }
  .navbar-light {
    background-color: $white;
    border-bottom: 2px solid $gray-300;
    margin-bottom: -1px;
  }
  .navbar-dark.bg-info {
    background-color: $navbar-dark-bg !important;
    @include gradient-x(mix($primary, $navbar-dark-bg, 50%), $navbar-dark-bg);
  }
  .navbar-brand {
    background: url('../../img/vendoscope-logo.png') center no-repeat;
    background-size: contain;
    color: transparent !important;
    width: 10rem;
    height: 2.6rem;
    margin-top: -.15rem;
    .navbar-dark & {
      background-image: url('../../img/vendoscope-logo-white.png');
    }
  }
  .navbar-nav {
    user-select: none;
    font-weight: $font-weight-bold;
    .nav-link {
      position: relative;
      padding-top: .72rem;
      padding-bottom: .9rem;
      text-transform: uppercase;
      letter-spacing: .03em;
      font-size: 92%;
      .navbar-dark & {
        text-shadow: 0 2px 3px rgba($gray-900, .2);
      }
    }
    .nav-link.active,
    .nav-item.active .nav-link {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: auto;
        left: $navbar-nav-link-padding-x;
        right: $navbar-nav-link-padding-x;
        height: 3px;
        background-color: $navbar-light-active-color;
        .navbar-dark & {
          background-color: rgba($white, .75);
        }
      }
    }
    .navbar-light & > .dropdown > .dropdown-menu {
      border-top: 2px solid $gray-400;
      margin-left: $navbar-nav-link-padding-x;
    }
    .nav-support {
      display: flex;
      justify-content: center;
      align-items: center;
      .nav-link {
        font-size: 23px;
        font-weight: bolder;
        padding-top: 4px;
        padding-bottom: 4px;
      }
    }
    .nav-news {
      display: none;
      /*display: flex;*/
      justify-content: center;
      align-items: center;
      .nav-link {
        font-size: 23px;
        font-weight: bolder;
        padding-top: 4px;
        padding-bottom: 4px;
        text-transform: lowercase;
      }
    }
    .nav-item {
      .nav-link {
        .notify-svg {
          width: 22px;
          margin-top: -2px;
        }
        .navbar-icons-title {
          color: #527f97;
          font-size: 15px;
          padding-left: 4px;
          text-transform: uppercase;
          letter-spacing: .03em;
          font-weight: 500;
        }
      }
    }
    .nav-notify,
    .nav-support {
      .nav-link {
        display: flex;
        align-items: center;
      }
    }
    .nav-notify {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 10px 0 0;
      .notify-primary-link {
        display: none;
      }
      .nav-link {
        position: relative;
          font-size: 15px;
          padding-left: 4px;
          font-weight: bolder;
        padding-top: 4px;
        padding-bottom: 4px;
        .notify-svg {
          width: 22px;
          margin-top: -2px;
        }
        .navbar-icons-title {
          color: #527f97;
          font-size: 15px;
          text-transform: uppercase;
          letter-spacing: .03em;
          font-weight: 500;
        }
      }
      .nav-link::before {
        content: '';
        position: absolute;
      }
      .nav-link::after {
        display: none;
      }
      .dropdown-menu {
        width: 270px;
      }
      .dropdown-row-innner {
        padding: 16px;
      }
      .notify-title {
        display: block;
        font-weight: 600;
        margin-bottom: 16px!important;
      }
      .notify-body {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 16px!important;
        color: #092433;

        -webkit-line-clamp: 12;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        overflow: hidden;
        display: -webkit-box;
      }
      .notify-underbody {
        text-decoration: none !important;
        color: #1890ff;
      }
      .notify-underbody:hover,
      .notify-underbody:active {
        color: #0050b3;
      }
      hr {
        border-top: 2px solid rgba(22,40,52,.1);
      }
      .dropdown-notices-link-block {
        padding: 16px;
      }
      .dropdown-notices-link {
        color: #1890ff;
        text-decoration: none;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        transition: color 0.3s;
      }
    }
  }
  @media (min-width: 991px) and (max-width: 1462px) {
    .navbar-nav .nav-notify {
      .navbar-icons-title {
        display: none;
      }
    }
    @media (min-width: 1281px) and (max-width: 1325px) {
      .nav-support {
        .navbar-icons-title {
          span {
            display: none;
          }
        }
      }
    }
    @media (max-width: 1280px) {
      .nav-support {
        .navbar-icons-title {
          display: none;
        }
      }
    }
  }
  @media (max-width: 991px) {
    .navbar-nav {
      .nav-notify {
        .dropdown-toggle {
          display: none;
        }
        .notify-primary-link {
          display: block;
        }
      }
      .nav-support,
      .nav-notify {
        justify-content: left;
        margin-bottom: 6px;
        .notify-primary-link {
          padding: 0;
        }
      }
    }
  }
  .navbar-icons-count{
    position: absolute;
    background-color: red;
    border-radius: 20px;
    font-size: 0.55em;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1em;
    top: -3px;
    left: -3px;
    color: greenyellow;
  }
  .navbar-icons-count-mini {
    position: absolute;
    background-color: red;
    border-radius: 20px;
    font-size: 0.5em;
    width: 14px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.1em;
    top: -4px;
    left: -4px;
    color: greenyellow;
  }
  .dropdown-notices {
    max-height: 350px;
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/navbar.vue